import React from 'react';
import Slider from "react-slick";
import img2 from "../../assets/images/case1.webp";
import img3 from "../../assets/images/case2.webp";
import img4 from "../../assets/images/case3.webp";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";


function Banner() {

    function chapterScroll(id) {
        var element = document.getElementById(id);
        var headerOffset = 200;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }

        const settings = {
            infinite: true,
            speed: 1500,
            arrows: false,
            slidesToShow: 2,
            autoplay: true,
            dots: true,
            autoplaySpeed: 5000,
            slidesToScroll: 1,
            // swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        adaptiveHeight: true,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        };
  return (
    <>
        <section className='banner-blog'>
            <div className='container'>
            <div className='meet-team-sec'>
                <div className='left'>
                   <div className='caption'>
                        <h2 className='ttl1'>Our Success Stories</h2>
                        <p className='sm-para'>Discover how Choice Techlab has turned challenges into success stories. Explore our case studies showcasing how we've partnered with clients to bring their visions to life.</p>
                   </div>
                   <div className='btn-View'>
                   <button className='btn' onClick={() => chapterScroll('explore')}><span>Explore the case studies</span></button>
                   </div>
                </div>
                <div className='right'>
                    <div className='slider-sec'>
                    <Slider {...settings}>
                        <div className='slide-items'>
                            <img src={img2} alt={"Our Success Stories"} className="img-fluid" height={461} width={421}/>
                        </div>
                        <div className='slide-items'>
                            <img src={img3} alt={"Our Success Stories"} className="img-fluid" height={461} width={421}/>
                        </div>
                        <div className='slide-items'>
                            <img src={img4} alt={"Our Success Stories"} className="img-fluid" height={461} width={421}/>
                        </div>
                    </Slider>
                    </div>
                </div>
            </div>
            <div className='shape-animation'>
                <div className='rectangle'>
                    <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.3672 3.92492C16.357 1.57499 20.1445 2.26031 21.1847 5.1585L27.0429 21.4806C28.0831 24.3788 25.5959 27.3162 22.5659 26.768L5.50139 23.6803C2.47139 23.132 1.17114 19.5093 3.16095 17.1594L14.3672 3.92492Z" fill="white" stroke="#E45525" strokeWidth="4"/>
                    </svg>
                </div>
               <div className='circle-1'></div>
            </div>
            <div className='shape-animation2'>
               <div className='circle-2'></div>
               <div className='circle-3'></div>
            </div>
            <div className='shape-animation3'>
               <div className='circle-4'></div>
               <div className='circle-5'></div>
            </div>
        </div>
           
        </section>
    </>
  )
}

export default Banner